import { SignInPage, SignInProviderConfig } from '@backstage/core-components';
import { githubAuthApiRef, googleAuthApiRef } from '@backstage/core-plugin-api';
import { ExtensionDefinition } from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  SignInPageProps,
} from '@backstage/plugin-app-react';

const authProviders: SignInProviderConfig[] = [
  {
    id: 'github-auth-provider',
    title: 'GitHub',
    message: 'Login via GitHub (recommended)',
    apiRef: githubAuthApiRef,
  },
  {
    id: 'google-auth-provider',
    title: 'Google',
    message: 'Login via Google',
    apiRef: googleAuthApiRef,
  },
];

const StaffbaseSignInPage = (props: SignInPageProps) => (
  <SignInPage {...props} providers={authProviders} align="center" />
);

export const signInPage: ExtensionDefinition = SignInPageBlueprint.make({
  params: {
    loader: async () => StaffbaseSignInPage,
  },
});
